export const NAVIGATION_BAR_HEIGHT = 72;
